import {search} from '../../sinclair/sinclair.media.utils';
import Backbone from 'backbone';
import Model from '../../models/media/videoModel';

const VideoCollection = Backbone.Collection.extend({
    url: '/api/rest/facade/video',
    model: Model,
    parse(data) {
        const that = this;
        if (data) {
            that.add(data.hasOwnProperty('data') ? data.data : data);
        }
        return this.models;
    },
    setUrl(url) {
        this.url = url;
        this.model.rootUrl = url;
        this.model.url = url;
    },
    updateOffset(total) {
        search.video.total = total;
        search.video.offset += this.length;
    },
});
export default VideoCollection;
